<script setup lang="ts">
import { Toaster } from '@/components/ui/sonner';
import OfflineBanner from '@/components/OfflineBanner.vue';

const backgrounds = ['/images/bg1.jpg', '/images/bg2.jpg', '/images/bg3.jpg'] as const;

const randomBackground = backgrounds[Math.floor(Math.random() * backgrounds.length)];
const currentYear = new Date().getFullYear();
</script>

<template>
    <div class="flex min-h-full flex-1 bg-white">
        <div class="flex flex-1 flex-col">
            <header class="px-4 pt-4 lg:px-10 lg:pt-6">
                <img
                    src="/images/logo-kleur.png"
                    alt="Maat Stalling"
                    class="h-12 w-auto"
                />
            </header>

            <main
                id="main-content"
                class="flex flex-1 flex-col"
            >
                <slot />
            </main>

            <footer class="px-4 pb-4 lg:px-10 lg:pb-6">
                <p class="text-sm text-gray-500">
                    &copy; Maat Stalling {{ currentYear }}
                </p>
            </footer>
        </div>

        <div class="relative m-4 hidden w-0 flex-1 lg:block">
            <img
                class="absolute inset-0 size-full rounded-[3rem] object-cover"
                :src="randomBackground"
                alt=""
            />
        </div>

        <Toaster />
        <OfflineBanner />
    </div>
</template>
